import styled, { css } from "styled-components";
import theme from "theme";
import Text from "../../Text";
import { CounterProps } from "../types";

export const StepCounterStyled = styled("div")<CounterProps>`
    display: inline-block;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    ${({ size, active }) => {
        const { sizes, activeColor, inactiveColor } = theme.stepper,
            { counterSize }: { counterSize: string } = sizes[size || "S"];

        return css`
            display: flex;
            height: 5px;
            width: 100%;
            line-height: ${counterSize};
            background: ${active ? activeColor : inactiveColor};
            /* This is the counter */
            ${Text.Style} {
                user-select: none;
                line-height: ${counterSize};
            }

            /* This is the description */
            & + ${Text.Style} {
                user-select: none;
                color: ${active ? activeColor : inactiveColor};
            }
        `;
    }}
`;

export const StepStyled = styled("div")`
    display: grid;
    align-items: center;
    width: 100%;
    ${({ onClick }) =>
        onClick &&
        css`
            * {
                cursor: pointer;
            }
        `}
`;
